export default "__VITE_ASSET__BEWCexg2__"